import { createContext, useContext } from "react";

/**
 * PropertyDetailContext — espone TUTTO lo stato e gli handler del componente
 * `PropertyDetail` ai sub-tab estratti in file separati (FotoTab,
 * AutopilotTab, MaterialiTab, …).
 *
 * Pattern: il parent monta `<PropertyDetailCtx.Provider value={ctx}>` con un
 * oggetto `ctx` che spreda TUTTE le variabili locali (state, setters,
 * handlers, refs). Ogni tab fa:
 *
 *   import { usePropertyDetail } from "../context";
 *   const { property, photos, onUpload, onEnhance, ... } = usePropertyDetail();
 *
 * Vantaggio rispetto a passare props: niente prop drilling esplicito da
 * mantenere allineato. Costo: ogni tab "vede" tutto, ma ognuno usa solo ciò
 * che serve (destrutturazione locale).
 */
export const PropertyDetailCtx = createContext(null);

export function usePropertyDetail() {
  const ctx = useContext(PropertyDetailCtx);
  if (!ctx) {
    throw new Error("usePropertyDetail deve essere usato dentro <PropertyDetailCtx.Provider>");
  }
  return ctx;
}
